<template>
  <div class="modal fade" role="dialog" id="schedule-delete-modal">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ transEdit('therapist-remove-schedule') }}</h5>
          <button type="button" class="close" data-dismiss="modal">
            <span><b>x</b></span>
          </button>
          <input type="hidden" id="customer-absent-modal-id">
        </div>
        <div class="modal-body">
          <h4>{{ transEdit('date-and-time') }}: </h4>
          <h5>
            <b><span id="schedule-delete-modal-date"></span>, </b>
            <span id="schedule-delete-modal-time"></span>
          </h5>
        </div>
        <div class="modal-footer">
          <button type="submit" @click="deleteBooking"
                  class="btn btn-danger">
            {{ transEdit('therapist-remove-schedule') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "admin-schedules-modal-delete-schedule",
  props: ['route_delete_schedule', 'schedule'],
  methods: {
    deleteBooking() {
      let self = this;
      let thisModal = $("#schedule-delete-modal");
      let route = self.route_delete_schedule.slice(0, -1);
      axios.delete(this.$portalUrl(route + self.schedule.id), {})
          .then(function (response) {
            self.$emit('refresh');
          })
          .catch(function (error) {
          });
      thisModal.modal('toggle');
    },
    closeModal() {
      this.$emit('close');
    },
  }
}
</script>

<style scoped>

</style>
